<button class="pop-no-button"
        (click)="toggle()">
  <span class="title">
    <ng-content></ng-content>
  </span>
  <i [class.fa-chevron-down]="isExpanded"
     [class.fa-chevron-right]="!isExpanded"
     class="chevron-icon far"></i>
</button>
